import { Map } from 'immutable';
import { createSelector } from 'reselect';

import * as VerificationConstants from './constants';
import * as D from './deps';
import * as ProtectedUtils from './protectedUtils';

export function getVerificationState(state) {
  return state.verification || Map();
}

export const getDiscountVerificationInfo = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO,
  ),
);

export const isDiscountVerificationInfoLoaded = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.isEqual(
    VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_INFO_IS_LOADED,
    true,
  ),
);

export const getDiscountVerificationStatus = createSelector(
  getDiscountVerificationInfo,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.DiscountVerificationInfoKeys.STATUS,
  ),
);

export const isEligibleForAutoVerification = createSelector(
  isDiscountVerificationInfoLoaded,
  getDiscountVerificationStatus,
  ProtectedUtils.isEligibleForAutoVerification,
);

export const getDiscountVerificationDocumentUploadUrl = createSelector(
  getDiscountVerificationInfo,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.DiscountVerificationInfoKeys.DOCUMENT_UPLOAD_URL,
  ),
);

export const getIsDiscountPaymentPageReady = createSelector(
  D.PaymentsSelectors.isAvailableProductsLoaded,
  D.PaymentsSelectors.isSubscriptionInfoLoaded,
  isDiscountVerificationInfoLoaded,
  getDiscountVerificationDocumentUploadUrl,
  D.PaymentsSelectors.getHasSeenPlanDetails,
  ProtectedUtils.getIsDiscountPaymentPageReady,
);

export const isDiscountVerificationStatusVerified = createSelector(
  getDiscountVerificationStatus,
  ProtectedUtils.isDiscountVerificationStatusVerified,
);

export const isInStudentReverificationPeriod = createSelector(
  D.PaymentsSelectors.getActiveProductDiscountType,
  isDiscountVerificationInfoLoaded,
  getDiscountVerificationStatus,
  ProtectedUtils.isInStudentReverificationPeriod,
);

export const isStudentReverificationDenied4Year = createSelector(
  getDiscountVerificationStatus,
  ProtectedUtils.isStudentReverificationDenied4Year,
);

export const getDiscountVerificationDiscountType = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.DiscountVerificationInfoKeys.DISCOUNT_TYPE,
  ),
);

export const getDiscountSearchAutoCompleteResults = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.ReducerKeys.DISCOUNT_ORG_SEARCH_RESULTS,
  ),
);

export const getDiscountVerificationErrorType = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_TYPE,
  ),
);

export const getDiscountVerificationErrorMessage = createSelector(
  getVerificationState,
  D.PaymentsProtectedUtils.getPropFromMap(
    VerificationConstants.ReducerKeys.DISCOUNT_VERIFICATION_ERROR_MESSAGE,
  ),
);
